import JSConfetti from 'js-confetti'

// Add confetti-click class to elements that should trigger confetti on click
document.addEventListener('DOMContentLoaded', () => {
    const confettiElems = document.querySelectorAll('.confetti-click')

    confettiElems.forEach((elem) => {
        elem.addEventListener('click', () => {
            const jsConfetti = new JSConfetti()
            jsConfetti.addConfetti()
        })
    })
})

// Listen for custom document.confetti event to trigger confetti
document.addEventListener('confetti', (event) => {
    const jsConfetti = new JSConfetti()
    jsConfetti.addConfetti()
})
